var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicationPillIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30501 16.1354C5.21474 17.0451 6.32237 17.5 7.62793 17.5C8.25293 17.5 8.85015 17.3819 9.4196 17.1458C9.98904 16.9097 10.496 16.5694 10.9404 16.125L16.5654 10.5C17.0099 10.0556 17.3502 9.54861 17.5863 8.97917C17.8224 8.40972 17.9404 7.8125 17.9404 7.1875C17.9404 5.88194 17.4856 4.77431 16.5758 3.86458C15.6661 2.95486 14.5585 2.5 13.2529 2.5C12.6279 2.5 12.0307 2.61806 11.4613 2.85417C10.8918 3.09028 10.3849 3.43056 9.94043 3.875L4.31543 9.5C3.87099 9.94444 3.53071 10.4514 3.2946 11.0208C3.05849 11.5903 2.94043 12.1875 2.94043 12.8125C2.94043 14.1181 3.39529 15.2257 4.30501 16.1354ZM8.7946 15.6042C8.4196 15.7569 8.03071 15.8333 7.62793 15.8333C6.7946 15.8333 6.08279 15.5382 5.49251 14.9479C4.90224 14.3576 4.6071 13.6458 4.6071 12.8125C4.6071 12.4097 4.68349 12.0208 4.83626 11.6458C4.98904 11.2708 5.20432 10.9444 5.4821 10.6667L7.94043 8.22917L12.2113 12.5L9.77376 14.9583C9.49599 15.2361 9.1696 15.4514 8.7946 15.6042Z",
    fill: "#087A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationPillIconSmall);
export default __webpack_public_path__ + "static/media/medication-pill-icon-small.f4f9ae1f1aa8d8572cdf7b2e756d50ff.svg";
export { ForwardRef as ReactComponent };